import React, { useState } from 'react';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import CrudManager from '../../../components/common/CrudManager';
import BpmFormService from '../../../services/BpmFormService';
import BpmFormEditor from './BpmFormEditor';

const BpmForm = () => {
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [activeFormId, setActiveFormId] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  const columns = [
    {
      key: 'formName',
      label: 'bpmForm.formName',
      sortable: true,
      showInFilter: true,
      filterSize: 'medium',
    },
    {
      key: 'formKey',
      label: 'bpmForm.formKey',
      sortable: true,
      showInFilter: true,
      filterSize: 'medium',
    },
    {
      key: 'enabled',
      label: 'common.enabled',
      sortable: true,
      showInFilter: true,
      filterType: 'checkbox',
      filterSize: 'small',
      showInGrid: false,
      type: 'checkbox',
      render: (row) => (row.enabled ? '✓' : '✗'),
    },
    {
      key: 'author',
      label: 'bpmForm.author',
      sortable: true,
      render: (row) => row.author || '-',
    },
    {
      key: 'formCreationDate',
      label: 'bpmForm.formCreationDate',
      sortable: true,
      render: (row) => (row.formCreationDate ? new Date(row.formCreationDate).toLocaleString() : ''),
    },
  ];

  return (
    <>
      <CrudManager
        key={`bpm-form-grid-${reloadKey}`}
        service={BpmFormService}
        columns={columns}
        entityName="bpmForm"
        icon={faFileLines}
        formLayout="modal"
        onAddClick={() => {
          setActiveFormId(null);
          setIsEditorOpen(true);
        }}
        onEditClick={(item) => {
          setActiveFormId(item?.id || null);
          setIsEditorOpen(true);
        }}
      />

      {isEditorOpen && (
        <BpmFormEditor
          embedded={true}
          formId={activeFormId}
          onDataChanged={() => setReloadKey((prev) => prev + 1)}
          onClose={() => setIsEditorOpen(false)}
        />
      )}
    </>
  );
};

export default BpmForm;
